import depositsWithdrawalsContent from './content/deposits-withdrawals.json';

const depositsWithdrawalsMock = {
    layoutType: 2,
    data: {
        name: 'deposits-and-withdrawals',
        layoutType: 2,
        areasList: [
            {
                id: 'deposits-withdrawals-page-area',
                name: 'Content',
                componentName: 'Comp:DepositsWithdrawalsPage',
                content: JSON.stringify(depositsWithdrawalsContent),
            },
        ],
    },
};

export default depositsWithdrawalsMock;
